module.exports = __webpack_public_path__ + "static/img/translation-icon.f61a731.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/translation-icon.png
// module id = zL4u
// module chunks = 1